export const getCollapsedEntryId = (entries: { id: number | null }[]) =>
	entries.length > 1 ? null : (entries[0]?.id ?? null);
